import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StringParam, useQueryParam } from 'use-query-params';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { FONT_GSS_FUTURA_BOLD } from '@monorepo/shared/src/themes/defaultTheme';
import ResourcesProvider from '@monorepo/shared/src/providers/ResourcesProvider';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import bitmap_background from 'assets/images/bitmap-background.png';
import MainLayout from 'components/layout/MainLayout';
import LetterResources from './LetterResources';
import LetterSelector from './LetterSelector';
import { mainLayoutHeaderProps } from '../../utils/reports-utils';

const t = (key: string, options?) => translate('reports', key, options);

const FamilyResourcesPage: React.FC = () => {
  const classes = useStyles();
  const [letter] = useQueryParam('letter', StringParam);
  const navigate = useNavigate();

  const letterSelectedCallback = (letter) => {
    navigate(`?letter=${letter}`);
  };

  return (
    <MainLayout
      scrollY={true}
      backgroundImg={bitmap_background}
      menuProps={mainLayoutHeaderProps(true, false)}
    >
      <Box className={classes.container}>
        <Box className={classes.topContainer}>
          <Box className={classes.titleContainer}>
            <Typography className={classes.title}>{t('familyResources')}</Typography>
            <Typography className={classes.subtitle}>{t('chooseResourceLetter')}</Typography>
          </Box>
        </Box>
        <LetterSelector
          selectedLetter={letter ?? undefined}
          letterSelectedCallback={letterSelectedCallback}
        />
        <ResourcesProvider>
          <LetterResources selectedLetter={letter ?? undefined} />
        </ResourcesProvider>
      </Box>
    </MainLayout>
  );
};

export default FamilyResourcesPage;

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    margin: '0 auto',
    height: '100%',
    alignItems: 'center',
    flexDirection: 'column',
  },
  topContainer: {
    maxWidth: 1024,
    margin: '0 auto',
    marginBottom: remCalc(24),
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
  },
  title: {
    fontSize: theme.typography.pxToRem(40),
    lineHeight: theme.typography.pxToRem(60),
    fontFamily: FONT_GSS_FUTURA_BOLD,
  },
  subtitle: {
    fontSize: theme.typography.pxToRem(24),
    lineHeight: theme.typography.pxToRem(36),
    fontFamily: FONT_GSS_FUTURA_BOLD,
    marginBottom: remCalc(24),
  },
}));
